import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import categoryReducer from "./slices/category";
import franchiseThemePageReducer from "./slices/franchiseThemePage";
import statReducer from "./slices/stats";
import desiginationReducer from "./slices/desigination";
import venueUserReducer from "./slices/venueUser";
import franchiseUserReducer from "./slices/franchiseUser";
import venueReducer from "./slices/venue";
import customer from "./slices/customer";
import orderSlice from "./slices/orderSlice";
import customerReservationSlice from "./slices/customerReservationSlice";
import itemReducer from "./slices/item";
import choiceGroupReducer from "./slices/choiceGroup";
import themeSlice from "./slices/themeSlice";
import cardSlice from "./slices/cardSlice";

export const rootPersistConfig = {
  key: "root",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

export const cateogoryPersistConfig = {
  key: "category",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

export const franchiseThemePagePersistConfig = {
  key: "franchiseThemePage",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

export const statPersistConfig = {
  key: "stat",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

export const desiginationPersistConfig = {
  key: "desigination",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

export const venueUserPersistConfig = {
  key: "venueUser",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

export const venuePersistConfig = {
  key: "venue",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

export const franchiseUserPersistConfig = {
  key: "franchiseUser",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};
export const choiceGroupPersistConfig = {
  key: "choiceGroup",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};
export const themePersistConfig = {
  key: "themeSlice",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};
const cartPersistConfig = {
  key: "cardSlice",
  storage,
  keyPrefix: "redux-",
  whitelist: ["isPickUp", "isDineIn"],
};

const rootReducer = combineReducers({
  category: persistReducer(cateogoryPersistConfig, categoryReducer),
  franchiseThemePage: persistReducer(franchiseThemePagePersistConfig, franchiseThemePageReducer),
  stat: persistReducer(statPersistConfig, statReducer),
  desigination: persistReducer(desiginationPersistConfig, desiginationReducer),
  franchiseUser: persistReducer(franchiseUserPersistConfig, franchiseUserReducer),
  venueUser: persistReducer(venueUserPersistConfig, venueUserReducer),
  venue: persistReducer(venuePersistConfig, venueReducer),
  customer: customer,
  orderSlice: orderSlice,
  customerReservationSlice: customerReservationSlice,
  item: itemReducer,
  choiceGroup: persistReducer(choiceGroupPersistConfig, choiceGroupReducer),
  themeSlice: persistReducer(themePersistConfig,themeSlice),
  cardSlice: persistReducer(cartPersistConfig,cardSlice),
});

export default rootReducer;
